import { orpcSuccessVoidResponseSchema } from "../util/success.mjs";
import { nanoIdSchema } from "../shared/id.mjs";
import { getByIdRoute } from "./getById.mjs";
import { acquirePreGenerationRoute } from "./preGeneration/acquire.mjs";
import { predictWaitTimeRoute } from "./waitTime.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/task/contract.ts
const taskContract = oc.prefix("/task").tag("Task").router({
	getById: getByIdRoute,
	cancelRunningTask: oc.route({
		summary: "Cancel a long-running task",
		description: "Cancels and refunds a task owned by the current user that has been running for at least 24 hours.",
		method: "POST",
		path: "/{id}/cancel"
	}).input(z.object({ id: nanoIdSchema })).output(orpcSuccessVoidResponseSchema).errors({
		NOT_FOUND: {
			status: 404,
			message: "Task not found"
		},
		BAD_REQUEST: {
			status: 400,
			message: "Task is not running or has not been running for at least 24 hours"
		},
		FORBIDDEN: {
			status: 403,
			message: "Not authorized"
		}
	}),
	predictWaitTime: predictWaitTimeRoute,
	acquirePreGenerated: acquirePreGenerationRoute
});
//#endregion
export { taskContract };
